import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import moment from "moment";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "ScheduledWineCogsModal",
  props: {
    wineId: {
      type: Number,
      default: 0
    },
    wineCogs: {
      type: Number,
      default: 0.01
    },
    wineNamingData: {
      type: Object,
      default: {}
    }
  },
  components: {
    Confirm: Confirm,
    WineNaming: WineNaming,
    ErrorModal: ErrorModal
  },
  data: function data(_this) {
    return {
      shown: false,
      isLoading: false,
      isAdding: false,
      options: {
        color: "primary",
        zIndex: 2000
      },
      openedPanels: [0],
      now: new Date(),
      minDate: moment().add(1, "days").toDate().formatForDatePickerDays(),
      scheduledModifications: [],
      form: {
        futureCogsEuro: _this.wineCogs,
        scheduledApplicationDate: moment().add(1, "months").startOf("month").toDate().formatForDatePickerDays()
      },
      managedExceptions: {
        warning: {
          conflict_date: "This product has already a scheduled price for this date."
        }
      },
      addDateMenu: null,
      futureHeaders: [{
        text: "Scheduled date",
        value: "scheduledApplicationDate",
        align: "left"
      }, {
        text: "Future Cogs (€)",
        value: "futureCogsEuro",
        align: "left"
      }, {
        text: "",
        value: "action",
        align: "right"
      }],
      previousHeaders: [{
        text: "Application date",
        value: "actualApplicationDate",
        align: "left"
      }, {
        text: "Cogs (€)",
        value: "futureCogsEuro",
        align: "left"
      }],
      rules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isInvalidForm: function isInvalidForm() {
      return this.form.futureCogsEuro <= 0 || this.form.scheduledApplicationDate <= this.now;
    },
    futureScheduledModifications: function futureScheduledModifications() {
      return this.scheduledModifications.filter(function (x) {
        return !x.actualApplicationDate;
      }).sort(function (a, b) {
        return new Date(a.scheduledApplicationDate) - new Date(b.scheduledApplicationDate);
      });
    },
    previousScheduledModifications: function previousScheduledModifications() {
      return this.scheduledModifications.filter(function (x) {
        return x.actualApplicationDate;
      }).sort(function (a, b) {
        return new Date(b.scheduledApplicationDate) - new Date(a.scheduledApplicationDate);
      });
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.getScheduledModifications();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    getScheduledModifications: function getScheduledModifications() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoading = true;
              _this = _this3;
              _context2.next = 4;
              return request("/v1/scheduled-wine-prices/wine/".concat(_this3.wineId), "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load scheduled modifications.");
                handleErrorData(_this, errorData);
                _this3.isLoading = false;
                throw e;
              });
            case 4:
              response = _context2.sent;
              _this3.scheduledModifications = _toConsumableArray(response.data.value);
              _this3.isLoading = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    addScheduledModification: function addScheduledModification() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isAdding = true;
              data = _objectSpread({}, _this4.form);
              data.wineId = _this4.wineId;
              _this = _this4;
              _context3.next = 6;
              return request("/v1/scheduled-wine-prices", "post", data, true, "api").catch(function (e) {
                _this.isAdding = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to add the scheduled modification.");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 6:
              _context3.next = 8;
              return _this4.getScheduledModifications();
            case 8:
              _this4.isAdding = false;
              _this4.$toasted.show("Scheduled modification added.", {
                type: "success"
              });
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    cancelScheduledModification: function cancelScheduledModification(item) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.$refs.confirm.open("Delete", "Are you sure you want to cancel this scheduled modification ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(confirm) {
                  var _this;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!confirm) {
                          _context4.next = 7;
                          break;
                        }
                        _this = _this5;
                        item.isDeleting = true;
                        _context4.next = 5;
                        return request("/v1/scheduled-wine-prices/" + item.id, "delete", null, true, "api").catch(function (e) {
                          item.isDeleting = false;
                          var errorData = getErrorData(e, _this.managedExceptions, "Unable to cancel scheduled modification.");
                          handleErrorData(_this, errorData);
                          throw e;
                        });
                      case 5:
                        _this5.getScheduledModifications();
                        _this5.$toasted.show("Scheduled modification cancelled.", {
                          type: "success"
                        });
                      case 7:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  }
};